import React, { useState } from 'react';
import axios from 'axios';
import config from '../config';
import { motion } from 'framer-motion';
import '../styles/contact.css';
import LoadingSpinner from '../components/LoadingSpinner';
import Notification from '../components/Notification';

const ContactUs = () => {
    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notification, setNotification] = useState({ message: '', type: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await axios.post(`${config.backendUrl}/communications/contact/`, formData);
            setNotification({ message: 'Message envoyé avec succès!', type: 'success' });
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            setNotification({ message: 'Erreur lors de l\'envoi du message.', type: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        window.history.back();
    };

    const isFormComplete = formData.name && formData.email && formData.subject && formData.message;

    return (
        <div className="contact-container">
            <motion.section className="vision-section" {...fadeIn} transition={{ delay: 0.6 }} style={{ textAlign: 'left' }}>
                <h1>Contactez-nous</h1>
                <p className="subtitle">Nous serions ravis de vous entendre!</p>
                {notification.message && (
                    <Notification
                        message={notification.message}
                        type={notification.type}
                        header={notification.header}
                        onClose={() => setNotification({ message: '', type: '' })}
                    />
                )}
                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nom</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Sujet</label>
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Message</label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <div className="form-actions">
                        <button type="button" className="cancel-button" onClick={handleCancel}>
                            Annuler
                        </button>
                        <button type="submit" className="submit-button" disabled={isSubmitting || !isFormComplete}>
                            {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
                        </button>

                    </div>
                </form>
            </motion.section>
            <div className="contact-details">
                <h2>Rejoignez-nous</h2>
                <p>Pour toute question ou demande, n'hésitez pas à nous contacter via le formulaire ci-dessus, WhatsApp, ou à nous rejoindre sur nos réseaux sociaux.</p>
                
                <div className="whatsapp-contact">
                    <h3>Contact WhatsApp</h3>
                    <p>Pour une assistance rapide, contactez-nous directement sur WhatsApp :</p>
                    <a 
                        href="https://wa.me/243851054526?text=Bonjour%2C%20je%20souhaite%20obtenir%20des%20informations%20sur%20Wennze.%20Pouvez-vous%20m%27aider%20%3F" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="whatsapp-link"
                    >
                        <i className="fab fa-whatsapp"></i>
                        Contactez-nous sur WhatsApp
                    </a>
                </div>

                <div className="social-links">
                    <a href="https://web.facebook.com/people/Wennze-Market/61575347631099/" target="_blank" rel="noopener noreferrer" className="social-link-item">
                        <i className="fab fa-facebook"></i>
                    </a>
                    <a href="https://www.instagram.com/application_wennze/" target="_blank" rel="noopener noreferrer" className="social-link-item">
                        <i className="fab fa-instagram"></i>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;